<template>
	<transition name="slide-left">
		<div
			class="tag-listing"
			v-if="$mq.isDesktop() && selectedTagName"
			:class="{ 'scrolled-down': isScrollingDown && mode === 'static' }"
		>
			<div class="tag-listing_inner">
				<div
					class="tag-all"
					@click="selectTag('all')"
					:class="{'tag-active': !selectedTagName}"
					v-html="`Tutti`"
				/>
				<div
					v-for="(tag, index) in tags"
					class="tag"
					@click="selectTag(tag.name)"
					:key="index"
					:class="{'tag-active': selectedTagName === tag.name}"
					v-html="tag.name"
				/>
			</div>
		</div>
	</transition>
</template>

<script>


export default {
	props: {
		selectedTagName: {
			type: String,
			default: null
		},
		isScrollingDown: {
			type: Boolean,
			default: false
		},
		mode: {
			type: String,
			default: null
		},
		tags: {
			type: Array,
			default: null
		},
		extras: {
			type: Array,
			default () {
				return null
			}
		}
	},

	methods: {
		selectTag (tag) {
			this.$emit('selectTag', tag)
		}
	}
}

</script>

<style scoped>
.slide-left-enter-active {
	transition: all .4s ease;
}

.slide-left-leave-active {
	transition: all .4s ease;
}

.slide-left-enter,
.slide-left-leave-to {
	max-width: 0px !important;
}

.tag-listing {
	position: relative;
	flex-shrink: 0;
	max-width: 240px;
	flex-basis: 240px;
	border-right: 1px solid #ededed;
	transition: all .5s ease;
}

.tag-listing.scrolled-down {
	transform: translateY(-80px);
}
.tag-listing_inner {
	padding: 30px;
	position: -webkit-sticky;
	position: sticky;
	top: 80px;
	overflow-x: hidden;
  padding-left: 10px;
}

.tag-section + .tag-section {
	margin-top: 30px;
}

.tag,
.tag-all {
	cursor: pointer;
	padding-bottom: 20px;
	border-radius: 4px;
	padding-left: 10px;
	white-space: nowrap;
}

.tag:not(.tag-all) {
	margin-left: 15px;
}

.tag-active {
	font-weight: bold;
}

@media (max-width: 1024px) {
	.tag-listing {
		padding: 0;
	}
}

</style>
